var _path, _g, _path2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVyoo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45417 0C2.44165 0 0 2.44165 0 5.45417V18.5451C0 21.5576 2.4424 24 5.45417 24H18.5458C21.5584 24 24 21.5576 24 18.5451V5.45417C24 2.44165 21.5584 0 18.5458 0H5.45417V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.49963 26.4996H26.5004V-2.5004H-2.49963V26.4996Z",
    fill: "#6173FE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00646 6.986C6.08346 7.068 6.70246 7.62 6.97246 9.718L8.04946 17.39C8.18446 18.467 9.15346 18.826 10.1495 18.826C10.8775 18.826 11.7995 18.634 12.5195 17.694L18.0675 8.918C18.6605 8.007 18.8765 7.538 18.8765 6.931C18.8765 5.109 16.2905 4.971 16.2635 5.026L10.9315 14.576L10.4465 9.553C10.3105 7.703 9.98846 6.489 9.26046 5.743C8.75046 5.22 8.15746 5 7.37646 5C5.19446 4.998 4.95246 6.986 5.00646 6.986Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.90247 22.066H21.9735V1.758H1.90247V22.066Z",
    fill: "#FEFEFE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVyoo);
export default __webpack_public_path__ + "static/media/vyoo.20cd6ab7.svg";
export { ForwardRef as ReactComponent };